module.exports = __webpack_public_path__ + "img/03.fea795d9.jpg";